export default __webpack_public_path__ + "static/media/select-arrow-up.8e21f0bb.svg";